import Icon from '../components/Icon';

/**
 * The `useronline` helper displays a green circle if the user is online.
 */
export default function userOnline(user) {
  if (user.lastSeenAt() && user.isOnline()) {
    return m("span", {
      className: "UserOnline"
    }, m(Icon, {
      name: 'fa-solid fa-circle',
      noStyleOverride: true
    }));
  }
  return null;
}
flarum.reg.add('core', 'common/helpers/userOnline', userOnline);